import { SUCCESS_MESSAGES, responseErrorToString } from '@zorro/common-utils';
import { Stack, Text } from '@zorro/web/design-system';
import {
  callEndpoint,
  showErrorNotification,
  showSuccessNotification,
  useLoadingOverlay,
} from '@zorro/web/ui-utils';
import pluralize from 'pluralize';

import { ModalFooter } from '../../ModalComponents';
import { RecordForActions } from '../EmployeeActionsUtils';

type WaiverConfirmationFormProps = {
  recordsForActions: RecordForActions[];
  onClose: () => void;
  onSuccess: () => void;
};

export const WaiverConfirmationForm = ({
  recordsForActions,
  onClose,
  onSuccess,
}: WaiverConfirmationFormProps) => {
  const isSingleEmployee = recordsForActions.length === 1;

  const { startLoading, stopLoading } = useLoadingOverlay();

  async function handleSubmit() {
    startLoading();
    const employeesIds: string[] = recordsForActions.map(
      (record) => record.employeeId
    );

    try {
      await Promise.all(
        employeesIds.map(async (employeeId) =>
          callEndpoint({
            method: 'enrollmentCommunicationsControllerSendWaiverConfirmation',
            params: [employeeId],
          })
        )
      );

      showSuccessNotification({
        message: SUCCESS_MESSAGES.getEmailSentSuccessfullyMessage(
          recordsForActions.length
        ),
      });

      onSuccess();
    } catch (error) {
      showErrorNotification({ message: responseErrorToString(error) });
    }
    stopLoading();
  }

  const text = isSingleEmployee
    ? 'Are you sure you want to send this email to the selected employee?'
    : 'Are you sure you want to send this email to all selected employees?';

  const submitText = `Send ${pluralize('email', recordsForActions.length)}`;

  return (
    <Stack gap="xxl">
      <Text>{text}</Text>
      <ModalFooter
        onClose={onClose}
        submitVariant="primary"
        submitText={submitText}
        onSubmit={handleSubmit}
      />
    </Stack>
  );
};
